import { render, staticRenderFns } from "./CustomerTables.vue?vue&type=template&id=488d251e&"
import script from "./CustomerTables.vue?vue&type=script&lang=js&"
export * from "./CustomerTables.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports